import { BookOpen, Wrench, Rocket, type LucideIcon } from "lucide-react";
import { useToolStats } from "@/hooks/useToolStats";

const HowItWorks = () => {
  const { totalValueLabel, loading } = useToolStats();
  const credits = loading ? "—" : totalValueLabel;

  const steps: { Icon: LucideIcon; title: string; description: string }[] = [
    {
      Icon: BookOpen,
      title: "Read the Playbook",
      description: "80+ sequenced prompts across 5 stages. Copy, paste, build.",
    },
    {
      Icon: Wrench,
      title: "Build with Free Tools",
      description: `Discover ${credits} in free credits and the exact tools used in every chapter.`,
    },
    {
      Icon: Rocket,
      title: "Get Co-Funded",
      description: "Submit your MVP to our network of seed funds actively backing AI-native founders.",
    },
  ];

  return (
    <section className="container mx-auto px-4 sm:px-6 lg:px-8 mb-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-black text-foreground tracking-tight">
          Three steps. One system.
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 relative">
        <div className="hidden md:block absolute top-16 left-[20%] right-[20%] border-t-2 border-dashed border-foreground/30 z-0" />

        {steps.map((step, i) => (
          <div key={step.title} className="relative z-10 flex flex-col items-center text-center">
            <div className="brutal-border brutal-shadow bg-card w-20 h-20 flex items-center justify-center rounded-md mb-4">
              <step.Icon className="w-9 h-9 text-foreground" aria-hidden />
            </div>
            <span className="text-xs font-black text-muted-foreground uppercase tracking-[0.08em] mb-2">
              Step {i + 1}
            </span>
            <h3 className="font-black text-lg text-foreground mb-2">{step.title}</h3>
            <p className="text-sm text-muted-foreground max-w-xs">{step.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
